import React, { useEffect, useState, useContext } from 'react'
import { Form, Field } from 'react-final-form'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { getFormErrorMessage } from '../utilities/FormHelpers'
import { UserContext } from '../UserContext.js';

/*
    props:
    values {}
    onSubmit (data)
*/
export const LevelForm = (props) => {
	const [buildingOptions, setBuildingOptions] = useState([]);
	const user = useContext(UserContext)
	useEffect(() => {
		user.apiCall(`levelformoptions`)
			.then((res) => setBuildingOptions(res.data))
	}, [])

	const validate = (formData) => {
		let errors = {};

		if(!formData.levelName || formData.levelName === "") {
			errors.levelName = "Name required";
		}

		if(!formData.buildingGuid) {
			errors.buildingGuid = "Building required";
		}

		return errors;
	}

	return (
		<Form
			onSubmit={props.onSubmit}
			validate={validate}
			initialValues={props.values}
			render={({handleSubmit}) => (
				<form onSubmit={handleSubmit} className="master-form">
					<Field name="levelName"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<InputText {...input}
										id="levelName"
									/>
									<label htmlFor='levelName'>Name:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<Field name="buildingGuid"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<Dropdown {...input}
										id="buildingGuid"
										options={buildingOptions}
										optionLabel="label"
									/>
									<label htmlFor='buildingGuid'>Building:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<div className='submit-footer'>
						<Button type="submit" label="Submit" />
					</div>
				</form>
			)}
		/>
	);
}